// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modal__daeAG {
  background-color: #fff;
  border: 1px solid var(--black-ten-opacity);
  border-radius: 1rem;
  position: fixed;
  z-index: var(--z-modal);
  left: 50%;
  transform: translateX(-50%);
  top: 10rem;
  max-height: 80vh;
  max-height: 80svh;
  max-width: 95%;
  display: flex;
  flex-direction: column;
}

.Modal_modal__header__8Ydbx {
  color: var(--primary-color);
  font-size: var(--text-lg);
  font-weight: 700;
  text-align: center;
  margin-block: 4rem;
  flex: 0 0 auto;
}

.Modal_modal__content-wrapper__O2-kH {
  overflow-y: auto;
  min-height: 20rem;
}

.Modal_modal__footer__zt3Yu {
  padding: 3.4rem 13rem 4rem 10rem;
  border-top: 0.5rem solid var(--black-ten-opacity);
  flex: 0 0 auto;
}

.Modal_modal__close-btn__8q14e {
  position: absolute;
  top: 3.6rem;
  right: 3.6rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Modals/Modal.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf","sourcesContent":[".modal {\n  background-color: #fff;\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  position: fixed;\n  z-index: var(--z-modal);\n  left: 50%;\n  transform: translateX(-50%);\n  top: 10rem;\n  max-height: 80vh;\n  max-height: 80svh;\n  max-width: 95%;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal__header {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  font-weight: 700;\n  text-align: center;\n  margin-block: 4rem;\n  flex: 0 0 auto;\n}\n\n.modal__content-wrapper {\n  overflow-y: auto;\n  min-height: 20rem;\n}\n\n.modal__footer {\n  padding: 3.4rem 13rem 4rem 10rem;\n  border-top: 0.5rem solid var(--black-ten-opacity);\n  flex: 0 0 auto;\n}\n\n.modal__close-btn {\n  position: absolute;\n  top: 3.6rem;\n  right: 3.6rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Modal_modal__daeAG`,
	"modal__header": `Modal_modal__header__8Ydbx`,
	"modal__content-wrapper": `Modal_modal__content-wrapper__O2-kH`,
	"modal__footer": `Modal_modal__footer__zt3Yu`,
	"modal__close-btn": `Modal_modal__close-btn__8q14e`
};
export default ___CSS_LOADER_EXPORT___;
